module.exports = __webpack_public_path__ + "static/media/approved.752e24cb.png";